<p class="infinity-title">{{ id ? 'Edit Role' : 'Add New Role' }}</p>

<!-- Loader -->
<div *ngIf="isLoading" class="loader-overlay">
  <div class="loader">Loading...</div>
</div>

<div class="infinity-section">
  <div class="col-span-2">
    <p class="infinity-sec-title mt-0">Role Information</p>
    <p class="infinity-sect-desc">Provide the necessary details for the role.</p>
  </div>

  <div class="col-span-10">
    <!-- Role Name Input -->
    <tui-input id="role-name" [(ngModel)]="name" (ngModelChange)="validateName()" class="w-[250px] h-3" [class.error]="nameInvalid" >Enter Role Name <input tuiTextfieldLegacy 
      type="text" /></tui-input>
    <!-- Error Message -->
    <div *ngIf="nameInvalid" class="error-message">Name is required</div>
  </div>
</div>

<div class="infinity-section">
  <div class="col-span-2">
    <p class="infinity-sec-title">Permissions</p>
    <p class="infinity-sect-desc">Select necessary permissions for the role.</p>
  </div>

  <div class="col-span-10 grid grid-cols-4 gap-5">
    <!-- Loop through Permission Groups -->
    <div *ngFor="let group of permissionGroups" class="permission-group">
      <p class="infinity-sec-title">{{ group.title }}</p>
      <p class="infinity-sect-desc mb-2">{{ group.description }}</p>

      <!-- Loop through Permissions within each group -->
      <div *ngFor="let perm of group.permissions" class="permission-item flex items-center gap-2">
        <input tuiCheckbox
        type="checkbox" size="s" [(ngModel)]="perm.checked" (ngModelChange)="updatePermissions(group.key, group.permissions)" />
        <label>{{ perm.label }}</label>
      </div>
    </div>
  </div>
</div>

<!-- Save or Update Button -->
<div class="flex flex-row justify-end my-5 gap-5">
  <div *ngIf="isLoading" class="small-loader">Loading...</div>
  <button appearance="primary" tuiButton [disabled]="isInvalid() || isLoading" (click)="addEditRole()"
    [appDisableUnlessPermission]="id ? 'ROLE_UPDATE' : 'ROLE_CREATE'">
    {{ id ? 'Update Role' : 'Save New Role' }}
  </button>
</div>
